import { Content } from "../../../components/Basic/Global";
import { H1 } from "../../../components/Basic/WrapsStyle";
import ProductsTable from "./ProductsTable";

function AdditionPage() {
  return (
    <Content>
      <H1>Занесение товара на склад</H1>

      <ProductsTable />
    </Content>
  );
}

export default AdditionPage;
